export default __webpack_public_path__ + "static/media/banner3.1dfb4c8d.jpg";